import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

// A PMS account waiting to be created, prefilled from an integration that
// hangs from none: the legacy app.baintex.com flow saved the credentials on
// the location's row itself, so "create an account" for it should not make
// the user type them again (BAC-672). `{ company, ...credentials }`, or
// `null`. The company's panel seeds a new editable row from it while it is
// in view; it is dropped once an account is saved or the panel closes.
export const PMSAccountDraftStore = GenericFieldFactory("PMS_ACCOUNT_DRAFT");
